module.exports = __webpack_public_path__ + "HelveticaNeueLTStdBd.d6a692226269e1bd9930.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/HelveticaNeueLTStdBd.woff2
// module id = ../../../../../src/assets/fonts/HelveticaNeueLTStdBd.woff2
// module chunks = styles